import {
  ProgressBar,
  SpecialZoomLevel,
  Viewer,
  Worker,
} from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

import { useSelector } from "react-redux";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

import "./index.css";

import "@react-pdf-viewer/toolbar/lib/styles/index.css";

export default function PDFViewer() {
  const selectedDoc = useSelector((state) => state.SOPViewer.selectedDoc);
  const userInfo = useSelector((state) => state.userInfo);

  const renderError = (error) => {
    
    let message = "";
    switch (error.name) {
      case "InvalidPDFException":
        message = "The document is invalid or corrupted";
        break;
      case "MissingPDFException":
        message = "The document is missing";
        break;
      case "UnexpectedResponseException":
        message = "Unexpected server response";
        break;
      default:
        message = "Cannot load the document";
        break;
    }

    return (
      <div
        style={{
          alignItems: "center",
          display: "flex",
          height: "100%",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#e53e3e",
            borderRadius: "0.25rem",
            color: "#fff",
            padding: "0.5rem",
          }}
        >
          {message}
        </div>
      </div>
    );
  };

  // Styles for the watermark container
  const watermarkContainerStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    zIndex: 100000, // Ensure it's behind the text and other elements
    pointerEvents: "none", // Allow text selection and clicks
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gridTemplateRows: "repeat(auto-fill, minmax(250px, 1fr))",
    alignItems: "center",
    justifyItems: "center",
    overflow: "hidden", // Prevents any overflow issues
  };

  // Styles for the individual watermark
  const watermarkStyle = {
    color: "rgba(0, 0, 0, 0.1)",
    // fontSize: "2.5rem",
    fontSize: "15px",
    fontWeight: "bold",
    transform: "rotate(-45deg)",

    overflow: "hidden",

    // lineHeight: "8.5em",
    // letterSpacing: "2px",
  };

  // const renderPage = (props) => {
  //   return (
  //     <>
  //       {props.canvasLayer.children}
  //       <div style={watermarkContainerStyle}>
  //         {Array.from({ length: 16 }).map((_, index) => (
  //           <div key={index} style={watermarkStyle}>
  //             {userInfo.email}
  //             <br />
  //             {new Date().toISOString()}
  //           </div>
  //         ))}
  //       </div>
  //       {props.annotationLayer.children}
  //       <div style={{ userSelect: "none" }}>{props.textLayer.children}</div>
  //     </>
  //   );
  // };

  const renderPage = (props) => (
    <>
      {props.canvasLayer.children}
      {/* 워터마크를 추가할 컨테이너 */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden" /* 컨테이너를 벗어나는 워터마크 숨기기 */,
          pointerEvents: "none" /* PDF 클릭/선택에 방해되지 않도록 설정 */,
        }}
      >
        {/* Grid 컨테이너 */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(3, 1fr)`,
            gridTemplateRows: `repeat(3, 1fr)`,
            width: "100%",
            height: "100%",
            justifyItems: "center" /* 그리드 아이템을 수평 중앙에 정렬 */,
            alignItems: "center" /* 그리드 아이템을 수직 중앙에 정렬 */,
          }}
        >
          {/* 그리드 아이템들 (워터마크) */}
          {Array.from({ length: 9 }).map((_, index) => (
            <div
              key={index}
              style={{
                fontSize: `${props.scale}rem` /* scale에 따라 크기 조절 */,
                color: "#d1d1d1",
                opacity: 0.4,
                fontWeight: "bold",
                transform: "rotate(-45deg)",
                userSelect: "none",
              }}
            >
              {userInfo.email}
              <br />
              {new Date().toISOString()}
            </div>
          ))}
        </div>
      </div>
      {props.annotationLayer.children}
      {props.textLayer.children}
    </>
  );

  const renderMoreActionsPopover = (toolbarSlot) => {
    const { Download, Print } = toolbarSlot;
    return (
      <>
        <Download />
        <Print />
      </>
    );
  };

  const renderToolbar = (Toolbar) => (
    <Toolbar>
      {(slots) => {
        const {
          GoToPreviousPage,
          GoToNextPage,
          ZoomIn,
          ZoomOut,
          ShowSearchPopover,
          Zoom,
          CurrentPageInput,
          NumberOfPages,
          EnterFullScreen,
        } = slots;
        return (
          <>
            <div style={{ padding: "0px 2px" }}>
              <ShowSearchPopover />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <ZoomOut />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <Zoom />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <ZoomIn />
            </div>
            <div style={{ padding: "0px 2px", marginLeft: "auto" }}>
              <GoToPreviousPage />
            </div>
            <div style={{ padding: "0px 2px", width: "4em" }}>
              <CurrentPageInput />
            </div>
            <div style={{ padding: "0px 2px" }}>
              / <NumberOfPages />
            </div>
            <div style={{ padding: "0px 2px" }}>
              <GoToNextPage />
            </div>
            <div style={{ padding: "0px 2px", marginLeft: "auto" }}>
              <EnterFullScreen />
            </div>
          </>
        );
      }}
    </Toolbar>
  );

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar,
    sidebarTabs: (defaultTabs) => [
      // Keep only the Thumbnails tab (index 0)
      defaultTabs[0],
    ],
  });

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
      <div
        style={{
          overflow: "auto",
          // height: 1100,
          borderTop: "1px solid #e0e0e0",
          // maxHeight: "calc(100vh - 200px)",
          height: "calc(100vh - 145px)",
        }}
      >
        <Viewer
          // fileUrl={`https://betree.beccocro.com:9000/api/SOPViewer/${selectedDoc.docNo}/${selectedDoc.ver}/${userInfo.employeeNo}?action=${selectedDoc.action}`}
          fileUrl={`${process.env.REACT_APP_BECCO_API_URL}/api/SOPViewer/${selectedDoc.docNo}/${selectedDoc.ver}/${userInfo.employeeNo}?action=${selectedDoc.action}`}
          withCredentials={true}
          defaultScale={SpecialZoomLevel.PageFit}
          plugins={[defaultLayoutPluginInstance]}
          // pageLayout={pageLayout}
          renderError={renderError}
          renderLoader={(percentages) => (
            <div style={{ width: "240px" }}>
              <ProgressBar progress={Math.round(percentages)} />
            </div>
          )}
          renderPage={renderPage}
        />
      </div>
    </Worker>
  );
}
